<div #focusTarget class="mgm-mail-modal">
    <div class="mgm-mail-modal-close">
        <i class="icon-edponline-Bop-071 " data-modal="dismiss()" (click)="close()" aria-hidden="true"></i>
    </div>
    <div class="mgm-mail-modal-container">
        <h2>{{ "pt.edp.edponline.planet.mgm-mail-modal.title" | translate }}</h2>
        <div class="email-form d-flex flex-column">
            <form [formGroup]="form" class="edp-form">
                <label>{{ "pt.edp.edponline.pack.discount.fe.label" | translate }}</label>
                <input
                    class="form-control"
                    type="email"
                    formControlName="email"
                    (focus)="inputFocus($event, focusTarget)"
                    id="email-input"
                    [ngClass]="{ 'form-control--error': !isValid && !!email, 'form-control--success': !!isSubmitted && mailSent }"
                />

                <div class="message-container" *ngIf="(lastResponse$ | async)">
                    <span class="message message--success" *ngIf="!!isSubmitted">
                        {{ "pt.edp.edponline.planet.mgm-mail-modal.valid-msg" | translate }}
                    </span>

                    <div class="message message--error">
                        <span *ngIf="form.controls.email.hasError('pattern') && !!email && !isSubmitted">
                            {{ "pt.edp.edponline.planet.mgm-mail-modal.invalid-msg" | translate }}
                        </span>
                    </div>
                </div>

                <div class="footer">
                    <button type="submit" class="btn btn-primary btn-accept" (click)="sendEmail()" [disabled]="!submitValidation">
                        {{ "pt.edp.edponline.planet.mgm-mail-modal.send" | translate }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
